export default __webpack_public_path__ + "static/media/index_5.953f2c86.png";